module.exports = __webpack_public_path__ + "img/Daugther.0458c468.svg";